export default {
  name: {
    label: "Nombre",
    id: "name",
    colClasses: "col",
    headerClasses: "fs-5 text-gray-700 fw-bolder justify-content-start",
    cellClasses: "d-flex align-items-center py-3",
  },
  description: {
    label: "Descripción",
    id: "description",
    colClasses: "col",
    headerClasses: "fs-5 text-gray-700 fw-bolder justify-content-start",
    cellClasses: "d-flex align-items-center py-3",
  },
  actions: {
    label: "Acciones",
    id: "actions",
    colClasses: "col",
    headerClasses: "text-center fs-5 text-gray-700 fw-bolder",
    cellClasses: "d-flex justify-content-center align-items-center",
  },
};
